import axios from "axios";

const instance = axios.create();
instance.defaults.headers.common["api-key"] =
  process.env.REACT_APP_POLL_PUBLIC_KEY;

export default instance;
